<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center">
      <h1 class="text-4xl font-bold mb-4">{{ error.statusCode }}</h1>
      <p class="text-gray-600 mb-6">{{ error.message }}</p>
      <UButton @click="handleError">
        {{ $t('common.back') }}
      </UButton>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  error: {
    statusCode: number;
    message: string;
  }
}>()

const handleError = () => {
  clearError()
  navigateTo('/')
}
</script> 